import React, { useEffect, useRef, useState } from 'react';
import { Lock } from 'lucide-react';

const KEY = 'tagws_lock_fab_pos';
const SIZE = 44;
const clamp = (p) => ({
  x: Math.min(Math.max(8, p.x), window.innerWidth - SIZE - 8),
  y: Math.min(Math.max(8, p.y), window.innerHeight - SIZE - 8),
});
const initial = () => {
  try { const p = JSON.parse(localStorage.getItem(KEY)); if (p && Number.isFinite(p.x)) return clamp(p); } catch { /* default */ }
  const mobile = window.innerWidth < 768;
  return clamp(mobile ? { x: window.innerWidth - SIZE - 12, y: window.innerHeight - SIZE - 170 } : { x: 344, y: window.innerHeight - SIZE - 24 });
};

// Super admin's draggable lock button (desktop + mobile); a tap / click opens the lock dialog.
export function TagLockFab({ onOpen }) {
  const [pos, setPos] = useState(initial);
  const drag = useRef(null);
  useEffect(() => {
    const onResize = () => setPos((p) => clamp(p));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const down = (e) => {
    e.currentTarget.setPointerCapture(e.pointerId);
    drag.current = { sx: e.clientX, sy: e.clientY, ox: pos.x, oy: pos.y, moved: false };
  };
  const move = (e) => {
    const d = drag.current;
    if (!d) return;
    const dx = e.clientX - d.sx; const dy = e.clientY - d.sy;
    if (!d.moved && Math.hypot(dx, dy) < 5) return;
    d.moved = true;
    setPos(clamp({ x: d.ox + dx, y: d.oy + dy }));
  };
  const up = () => {
    const d = drag.current;
    drag.current = null;
    if (!d) return;
    if (d.moved) setPos((p) => { localStorage.setItem(KEY, JSON.stringify(p)); return p; });
    else onOpen();
  };
  return (
    <button type="button" aria-label="Portal lock (drag to move)" title="Portal lock — drag to move"
      onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerCancel={() => { drag.current = null; }}
      style={{ left: pos.x, top: pos.y, width: SIZE, height: SIZE, touchAction: 'none' }}
      className="fixed z-[60] grid cursor-grab select-none place-items-center rounded-full border border-border bg-card/95 text-red-600 shadow-lg backdrop-blur transition-shadow duration-150 hover:shadow-xl active:cursor-grabbing"
      data-testid="tagws-portal-lock-fab"><Lock size={18} /></button>
  );
}
